import actionTypes from 'user/actions/trusted-devices.action-types';

export default (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_TRUSTED_DEVICES_SUCCESS:
      return [...action.devices];
    case actionTypes.DELETE_TRUSTED_DEVICE_SUCCESS:
      return state.filter((device) => device.uuid !== action.uuid);
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/user/reducers/trusted-devices.reducer.js